import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Font Awesome CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
